import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import I from 'immutable';
import translate from 'lib/translate';
import { formatPrice } from 'lib/units';
import {
  SUBSCRIPTION_TYPE_MEMBER,
  SUBSCRIPTION_TYPE_COLLECTOR,
  SUBSCRIPTION_TYPE_PROFESSIONAL,
  SUBSCRIPTION_TYPE_ENTERPRISE,
  DEFAULT_RTV_PRICE,
} from 'domain/const';
import MostPopular from 'pages/common/mostPopular';

import injectSheet from 'lib/sheet';
import styles from './sheet.js';

function Valuations({ subscriptionType, className, freeRtv }) {
  let text = null;
  switch (subscriptionType) {
    case SUBSCRIPTION_TYPE_MEMBER:
      text = 'Unlimited searches of the Auction Sales Database at an unbeatable price';
      break;
    case SUBSCRIPTION_TYPE_COLLECTOR:
      text = `Access to Market Insights and ${freeRtv} ARTBnk Values for the data-driven collector`;
      break;
    case SUBSCRIPTION_TYPE_PROFESSIONAL:
      text = `Save big on ${freeRtv} ARTBnk Values for the informed market insider`;
      break;
    case SUBSCRIPTION_TYPE_ENTERPRISE:
    default:
      text = 'If you see this please contact us';
      break;
  }
  return <div
    className={className}
    children={text}
  />;
}

Valuations.propTypes = {
  className: PropTypes.string,
  subscriptionType: PropTypes.string,
  freeRtv: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

function P({ children }) {
  return <p children={children} className="p" />;
}

P.propTypes = {
  children: PropTypes.node,
};

const getDiscount = (subscriptionValue, freeRtv) => subscriptionValue === 1800 ? 65 : Math.ceil((1 - subscriptionValue / (freeRtv * DEFAULT_RTV_PRICE)) * 100);

function Description({ subscriptionType, className, freeRtv, subscriptionValue }) {
  let text = null;
  switch (subscriptionType) {
    case SUBSCRIPTION_TYPE_MEMBER:
      text = <React.Fragment>
        <P>{freeRtv} FREE ARTBnk Value (one-time credit)</P>
        <P>Unlimited Auction Sales Database searches</P>
        <P>Unlimited Auction Alerts</P>
        <P>Unlimited Collection Management</P>
      </React.Fragment>;
      break;
    case SUBSCRIPTION_TYPE_COLLECTOR:
      text = <React.Fragment>
        <P>Everything in Member, plus:</P>
        <P>+ {freeRtv} ARTBnk Values: ${formatPrice({ value: DEFAULT_RTV_PRICE * freeRtv })} value and {getDiscount(subscriptionValue, freeRtv)}% savings per valuation</P>
        <P>{'+ Market Insights: track the financial performance of the world\'s leading artists'}</P>
      </React.Fragment>;
      break;
    case SUBSCRIPTION_TYPE_PROFESSIONAL:
      text = <React.Fragment>
        <P>Everything in Member, plus:</P>
        <P>+ {freeRtv} ARTBnk Values: ${formatPrice({ value: DEFAULT_RTV_PRICE * freeRtv })} value and {getDiscount(subscriptionValue, freeRtv)}% savings per valuation</P>
        <P>{'+ Market Insights: track the financial performance of the world\'s leading artists'}</P>
      </React.Fragment>;
      break;
    case SUBSCRIPTION_TYPE_ENTERPRISE:
    default:
      text = 'If you see this please contact us';
      break;
  }
  return <div
    className={className}
    children={text}
  />;
}

Description.propTypes = {
  className: PropTypes.string.isRequired,
  subscriptionType: PropTypes.string,
  freeRtv: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  subscriptionValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

class SubscriptionType extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
    item: PropTypes.instanceOf(I.Collection).isRequired,
    modifier: PropTypes.string,
  };

  static defaultProps = {
    onClick: () => null,
  };

  render() {
    const { classes, onClick, selected, disabled, item, modifier } = this.props;
    const subscriptionType = item.get('shortName');
    return (
      <button
        type="button"
        className={cx(classes.SubscriptionType, modifier, subscriptionType, { active: selected }, { disabled: disabled })}
        onClick={onClick}
      >
        <h3
          className={classes.title}
          children={translate(`subscriptionType.${subscriptionType}.title`)}
        />
        {
          subscriptionType === SUBSCRIPTION_TYPE_PROFESSIONAL &&
            <div className={classes.mostPopular}>
              <MostPopular />
            </div>
        }
        {
          (/*false && */subscriptionType !== SUBSCRIPTION_TYPE_ENTERPRISE) &&
            <React.Fragment>
              <Valuations
                className={cx(classes.valuations, modifier)}
                subscriptionType={subscriptionType}
                freeRtv={item.get('freeRtvCountIncluded')}
              />
              <Description
                className={classes.descriptionPrice}
                subscriptionType={subscriptionType}
                freeRtv={item.get('freeRtvCountIncluded')}
                rtvDefaultValue={item.get('rtvDefaultValue')}
                subscriptionValue={item.get('subscriptionValue')}
              />
            </React.Fragment>
        }
        <div
          className={cx(classes.yearPriceWrapper, modifier)}
        >
          <span
            className={classes.yearPrice}
            children={`$${formatPrice({ value: item.get('subscriptionValue') })}`}
          />
          <span
            className={classes.yearPricePeriod}
            children={subscriptionType === SUBSCRIPTION_TYPE_MEMBER ? ' / month' : ' / year'}
          />
        </div>
      </button>
    );
  }
}

export default injectSheet(styles)(SubscriptionType);
